import { render, staticRenderFns } from "./DisasterTypeSelector.vue?vue&type=template&id=450c61f6&scoped=true&"
import script from "./DisasterTypeSelector.vue?vue&type=script&lang=js&"
export * from "./DisasterTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c61f6",
  null
  
)

export default component.exports